/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import { connect } from 'react-redux';
import { openSnackLoading, openSnack } from '../actions/snackBar.action';

class ErrorBoundary extends Component{

  constructor (props){
    super(props);
    this.state={error:false};
  }

  static getDerivedStateFromError (error){
    return {error:true};
  }
  componentDidCatch (error, errorInfo){
    this.props.openSnack({alertType:'error', alertMessage:'problem ocuured'});
    console.log(error, errorInfo);
  }
  render (){
    if (this.state.error){
      return (
        <div style={{background:'red', color:'white'}}>
             problems occurred
        </div>
      );
    }
    return this.props.children;
  }
}

const mapStateToProps = (state) => {
  return {
    isAdmin: state.authReducer.user.admin,
    userInfo:state.authReducer.user,
  };
};
 
const mapDispatchToProps = (dispatch) => {
  return {
    openSnack: (payload) => dispatch(openSnack(payload)),
    openSnackLoading:(payload) => dispatch(openSnackLoading(payload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
